/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Team_Members_LabelInputs */

const en_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Members`)
};

const fr_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres de l’équipe`)
};

const de_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teammitglieder`)
};

const it_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri del team`)
};

const ru_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Члены команды`)
};

const es_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros del equipo`)
};

const zh_cn2_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队成员`)
};

const ja_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームメンバー`)
};

const hi_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम के सदस्य`)
};

const pt_pt2_team_share_team_members_label = /** @type {(inputs: Team_Share_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros da equipe`)
};

/**
* | output |
* | --- |
* | "Team Members" |
*
* @param {Team_Share_Team_Members_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_team_members_label = /** @type {((inputs?: Team_Share_Team_Members_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Team_Members_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_team_members_label(inputs)
	if (locale === "de") return de_team_share_team_members_label(inputs)
	if (locale === "it") return it_team_share_team_members_label(inputs)
	if (locale === "ru") return ru_team_share_team_members_label(inputs)
	if (locale === "es") return es_team_share_team_members_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_team_members_label(inputs)
	if (locale === "ja") return ja_team_share_team_members_label(inputs)
	if (locale === "hi") return hi_team_share_team_members_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_team_members_label(inputs)
	return en_team_share_team_members_label(inputs)
});